exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_easter_1fZ7upWDJV4nxxrLAHDObp {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 6000000;\n  pointer-events: none;\n  background-position: center;\n  background-size: cover;\n  overflow: hidden;\n}\n\n.IA_easterEggContainer_t1B-uq7cDq8pe60Z2CX54 {\n  position: absolute;\n  bottom: 0px;\n}", ""]);

// Exports
exports.locals = {
	"IA_easter": "IA_easter_1fZ7upWDJV4nxxrLAHDObp",
	"IA_easterEggContainer": "IA_easterEggContainer_t1B-uq7cDq8pe60Z2CX54"
};